import { Button, Checkbox, Tooltip } from 'antd';
import React, { useState } from 'react';
import catchError from '../../utils/catchError';
import doAxiosRequest from '../../utils/doAxiosRequest';
import { useStateValue } from '../../providers/StateProvider';

const AvisoEntidad = () => {
    const [{ token }, dispatch] = useStateValue();
    const [isSelected, setIsSelected] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSelect = ({ target: { checked } }) => {
        setIsSelected(checked);
    };

    const handleSave = catchError(async () => {
        const { ok } = await doAxiosRequest(
            '/general/general/avisoPrivacidad',
            'POST',
            token,
            dispatch,
            { },
            setLoading,
        );
        if (ok) {
            dispatch({ type: 'SET_AVISO_PRIVACIDAD' });
            localStorage.removeItem('avisoPrivacidad');
        }
    });
    return (
        <div className="d-flex flex-column h-100">
            <Checkbox onChange={handleSelect} style={{ fontSize: '25px', margin: '10px' }}>
                Confirmo que he leído el
                {' '}
                <a href="https://ease.gob.mx/assets/pdf/AVISODEPRIVACIDADINTEGRALYSIMPLIFICADOBUZON.pdf" target="_blank" rel="noreferrer">aviso de privacidad del Buzón Digital.</a>
            </Checkbox>
            <div>
                <Tooltip title={(!isSelected) ? 'Para continuar debe aceptar el aviso de privacidad.' : ''}>
                    <Button
                        loading={loading}
                        disabled={!isSelected}
                        type="primary"
                        style={{ margin: '10px', width: '120px' }}
                        onClick={handleSave}
                    >
                        Continuar
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
};

export default AvisoEntidad;
